"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION = exports.STAGING = exports.DEVELOPMENT = exports.LOCAL = void 0;
exports.LOCAL = 'local';
exports.DEVELOPMENT = 'dev';
exports.STAGING = 'staging';
exports.PRODUCTION = 'prod';
